import { renderToString } from 'react-dom/server'

import { ActivePointBoxberry } from '../assets/ActivePointBoxberry'
import { ActivePointDalli } from '../assets/ActivePointDalli'
import { ActivePointFive } from '../assets/ActivePointFive'
import { ActivePointSdek } from '../assets/ActivePointSdek'
import { PointBoxberry } from '../assets/PointBoxberry'
import { PointCdek } from '../assets/PointCdek'
import { PointDalli } from '../assets/PointDalli'
import { PointFive } from '../assets/PointFive'

export const getIconLayout = (partner: string, isActive: boolean) =>
	renderToString(
		<>
			{partner === `5POST` && (isActive ? <PointFive /> : <ActivePointFive />)}
			{partner === `SDEK` && (isActive ? <ActivePointSdek /> : <PointCdek />)}
			{partner === `DS` && (isActive ? <ActivePointDalli /> : <PointDalli />)}
			{partner === `BOXBERRY` && (isActive ? <ActivePointBoxberry /> : <PointBoxberry />)}
		</>
	)
